module.exports = __webpack_public_path__ + "img/logo.1543b532.png";